// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"SenditTable_blockClick_1IdkX"};